const PREFERRED_LINKS_IN_COLUMN = 7;

export function getLinksByColumns<T>(items: T[]): T[][] {
  if (items.length <= PREFERRED_LINKS_IN_COLUMN) {
    return [items];
  }

  let columnsCount = 2;
  if (items.length <= columnsCount * PREFERRED_LINKS_IN_COLUMN) {
    return [
      items.slice(0, Math.ceil(items.length / columnsCount)),
      items.slice(Math.ceil(items.length / columnsCount)),
    ];
  }

  columnsCount = 3;
  const linksInColumn1 = Math.ceil(items.length / columnsCount);
  const linksInColumn2And3 = items.length - linksInColumn1;
  const linksInColumn2 = Math.ceil(linksInColumn2And3 / 2);

  return [
    items.slice(0, linksInColumn1),
    items.slice(linksInColumn1, linksInColumn1 + linksInColumn2),
    items.slice(linksInColumn1 + linksInColumn2),
  ];
}
